export default "/Frontend/dist/event-background4-grey.5eaf7d50c1183a60e72fa10cc90c9919.svg";